export const Const = {
    USER: {url: "/user", title: "회원 관리"},
    EXPERT: {url: "/expert", title: "전문가 관리"},
    TEST: {url: "/test", title: "시험 관리"},
    GRADING: {url: "/grading", title: "채점 관리"},
    BLOG: {url: "/blog", title: "블로그"},
    SUPPORT: {url: "/support", title: "고객지원"},
    SITE: {url: "/site", title: "사이트 관리"},
    CATEGORY: {url: "/category", title: "카테고리 관리"},
    TRANSACTION: {url: "/transaction", title: "결제/정산 관리"},
    ADMIN: {url: "/admin", title: "관리자 설정"},
    TEMPLATE: {url: "/template", title: "양식 관리"}
}
export const LOGIN = "/login";

export const ALL_LABEL = "전체";
export const ALL = "all";

export const D_USER_TYPE = [ALL_LABEL, "일반", "정식"]
export const L_USER = " 회원"
export const D_SUBSCRIPTION = [ALL_LABEL, "베이직", "스탠다드", "프리미엄"]
export const L_SUBSCRIPTION = " 구독"
export const D_TEST_SUBJECT = [ALL_LABEL]
export const D_TEST_DEGREE = [ALL_LABEL]
export const D_EXAM_SUBJECT = [ALL_LABEL]
export const D_CATEGORY = [ALL_LABEL]
export const D_BOUNDARY = [ALL_LABEL]

export const D_EXPERT_STATUS = [ALL_LABEL, "요청", "승인", "승인 대기", "거절"]
export const L_EXPERT = "전문가 "
export const D_EXPERT_REQUEST = [ALL_LABEL]
export const D_EXPERT_CATE_B = [ALL_LABEL]
export const D_EXPERT_CATE_M = [ALL_LABEL]
export const D_EXPERT_CATE_S = [ALL_LABEL]

export const D_TEST_ADMIS_YEAR = [ALL_LABEL]
export const D_TEST_ADMIS_ROUND = [ALL_LABEL]
export const D_TEST_APPLIC_STAT = [ALL_LABEL]
export const D_TEST_SUBMIT_STAT = [ALL_LABEL]
export const D_TEST_STAT = [ALL_LABEL]
export const D_TEST_GRADE_STAT = [ALL_LABEL]

export const REST_URL = 'https://pgrst.aiteditor.org/'
export const MAX_PATH = 'activity_test_problem_id_max'